export default __webpack_public_path__ + "gimp.07ad8e0f.png";